// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U7):
// the loader prefetches the list, so a failed read errors only its part (D193).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../../../components/ui/page-header'
import { InvitationsList } from '../../../../features/members/InvitationsList'
import { PeopleTabs } from '../../../../features/members/PeopleTabs'
import { invitationsQuery } from '../../../../features/members/queries'
import { Part } from '../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/people/invitations')({
  staticData: { screenId: 'InvitationsListScreen', access: 'member.invite' },
  loader: async ({ context: { queryClient, membership } }) => {
    await queryClient.prefetchQuery(invitationsQuery(membership.orgId))
    return { orgId: membership.orgId }
  },
  component: InvitationsListScreen,
})

function InvitationsListScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  const { orgSlug } = Route.useParams()
  return (
    <main data-testid={ids.invitationsList.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('members.people.title')} />
      <PeopleTabs orgId={orgId} orgSlug={orgSlug} current="invitations" />
      <Part testId={ids.invitationsList.skeleton}>
        <InvitationsList orgId={orgId} />
      </Part>
    </main>
  )
}
